import * as React from 'react';

import classNames from 'classnames';

import DiscussionEffortText from 'bundles/learner-progress/components/item/DiscussionEffortText';
import PeerReviewEffortText from 'bundles/learner-progress/components/item/PeerReviewEffortText';
import ProjectEffortText from 'bundles/learner-progress/components/item/ProjectEffortText';
import TimeCommitmentEffortText from 'bundles/learner-progress/components/item/TimeCommitmentEffortText';
import WiseFlowEffortText from 'bundles/learner-progress/components/item/WiseFlowEffortText';
import type { Item } from 'bundles/learner-progress/types/Item';
import {
  getIsAssignmentPartForSplitPeer,
  getIsMentorGraded,
  getIsReviewPartForSplitPeer,
} from 'bundles/learner-progress/utils/Item';

import _t from 'i18n!nls/learner-progress';

import 'css!./__styles__/EffortText';

type Props = {
  computedItem: Item;
};

const EffortText = ({ computedItem: item }: Props) => {
  const classes = classNames('rc-EffortText', 'caption-text', 'text-hint');

  if (item.hasOutcomeOverride) {
    return <span className={classes}>{_t('Your grade has been overridden')}</span>;
  } else if (getIsAssignmentPartForSplitPeer(item) || getIsMentorGraded(item)) {
    return <PeerReviewEffortText item={item} className={classes} />;
  } else if (
    ['quiz', 'exam', 'staffGraded', 'teammateReview', 'gradedLti', 'ungradedAssignment'].includes(
      item.contentSummary.typeName
    )
  ) {
    return <ProjectEffortText item={item} className={classes} />;
  } else if (['wiseFlow'].includes(item.contentSummary.typeName)) {
    return <WiseFlowEffortText item={item} className={classes} />;
  } else if (item.contentSummary.typeName === 'gradedDiscussionPrompt') {
    return <DiscussionEffortText item={item} className={classes} />;
  } else if (!getIsReviewPartForSplitPeer(item)) {
    return <TimeCommitmentEffortText timeCommitment={item.timeCommitment} className={classes} />;
  }

  return null;
};

export default EffortText;
